import { ITriageRequest, ITriageRequestUpdate } from '~/services/api/triage/types';

const getInitialValues = (request: ITriageRequest): ITriageRequestUpdate => ({
  ...request,
});

export default getInitialValues;
